/* eslint-disable typescript-sort-keys/string-enum */ var Widths = /*#__PURE__*/ function(Widths) {
    Widths["None"] = "";
    Widths["Xxsmall"] = "xxsmall";
    Widths["Xsmall"] = "xsmall";
    Widths["Small"] = "small";
    Widths["Medium"] = "medium";
    Widths["Large"] = "large";
    Widths["Xlarge"] = "xlarge";
    Widths["Xxlarge"] = "xxlarge";
    return Widths;
}({});

export { Widths };
//# sourceMappingURL=widths.js.map
